import React from "react";
import Button from "@components/Button/Button";
import type { Task } from "@services/vesselCall/types";
import { t } from "i18next";
import { canUserResumeResumption } from "../utils";

interface RejectResumptionProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
  };
  interruptionTaskStatus?: string;
  claimOwnerName?: string;
  openDrawer: (drawerName: string) => void;
  refetchVesselCall: () => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const RejectResumption: React.FC<RejectResumptionProps> = ({
  vesselCallFlowData,
  openDrawer,
  refetchVesselCall,
  interruptionTaskStatus,
  claimOwnerName,
}) => {
  if (!vesselCallFlowData) {
    return null;
  }

  const taskStatus = interruptionTaskStatus;
  const ownerName = claimOwnerName;
  const isActionAvailable =
    taskStatus != null && ownerName != null && canUserResumeResumption(taskStatus, ownerName);

  const handleRejectClick = () => {
    refetchVesselCall();
    openDrawer("rejectResumeDrawer");
  };

  if (!isActionAvailable) return null;
  return (
    <Button
      testId="reject-resumption"
      variant="outlined"
      disabled={!isActionAvailable}
      onClick={handleRejectClick}
      className="whitespace-nowrap"
      label={<span className="normal-case font-medium">{t(`${LANG_BASE}.reject-button`)}</span>}
    />
  );
};

export default RejectResumption;
